<template>
    <div class="main">
        <div class="toptab">
            <div class="tabBtn" :class="select=='1'?'active':''" @click="selectComponents('1')">登入</div>
            <div class="tabBtn" :class="select=='2'?'active':''" @click="selectComponents('2')">註冊</div>
        </div>
        <transition name="component-fade" mode="out-in">
            <ComtentA v-if="select==1" @showMask="showMask"></ComtentA>
        </transition>
        <transition name="component-fade" mode="out-in">
            <ComtentB v-if="select==2" @showMask="showMask"></ComtentB>
        </transition>
        <common-mask v-if="isMask" @closeMask="closeMask"></common-mask>
    </div>
</template>

<script>
import ComtentA from '@/components/logins'
import ComtentB from '@/components/register'
import CommonMask from '@/components/mask'
export default {
    data() {
        return {
            content: '',
            select: '1',
            isMask: false
        }
    },
    components: { ComtentA, ComtentB,CommonMask },
    mounted: function () {},
    methods: {
        selectComponents: function (e) {
            this.select = e
        },
        showMask() {
            this.isMask = true;
        },
        closeMask() {
            this.isMask = false;
        }
    },
    computed: {},
}
</script>

<style lang="css" scoped>
.main {
    width: 100%;
    position: relative;
    top: 0;
    padding-top: 200px;
    background-color: #f3f4f2;
}
.toptab {
    width: 900px;
    margin: 0 auto;
    display: flex;
    flex-flow: row nowrap;
    justify-content: center;
}
.toptab .active {
    color: #ef653d;
}
.tabBtn {
    color: #333;
    font-size: 24px;
    margin: 0 50px;
    padding: 5px 8px;
    box-sizing: border-box;
    border-radius: 10px;
    cursor: pointer;
    padding-bottom: 100px;
}
.component-fade-enter-active,
.component-fade-leave-active {
    transition: opacity 0.2s ease-out;
}
.component-fade-enter, .component-fade-leave-to
/* .component-fade-leave-active for below version 2.1.8 */ {
    opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/login.vue